define(function (require) {
    require("@modules/tools/ko.async");
    require("@modules/tools/ko.extensions");

    var ko = require("knockout");
    var $ = require("jquery");
    // var _ = require("underscore");
    var FormularyResultViewModel = require("@modules/tools/formulary-search/formularyResultViewModel");
    var urlParameters = require("@modules/tools/urlParameters");
    var querystring = require("querystring");
    var getPropertyCaseInsensitive = require("@modules/insensitiveProperty");
    var utility = require("@modules/tools/helpfulToolUtility");
    var whitelistUrlService = require("@modules/tools/whitelistUrlService");

    // FormularySearchViewModel ctor
    return function (gtmDataLayerPush) {
        var self = this;
        var focusedElement;

        // If any of the arrays below start with an item
        // helpfulToolUtility.filtersHaveNonDefaultValues will need updated
        var defaultParameters = {
            pageNumber: 1,
            year: window.scan.aepYears[window.scan.aepYears.length - 1]
        };

        var dataLayer = window.dataLayer || [];
        var url = window.location.href.replace(/^.*\/\/[^\/]+/, "").split("?")[0];
        dataLayer.push({
            event: "gaPageview",
            eventCategory: "Pageview",
            eventAction: url,
            eventLabel: "Formulary Search"
        });

        var initialLoad = true;
        var pageSize = window.scan.resultPageSize > 0 ? window.scan.resultPageSize : 4;
        var tempResults = [];

        self.currentSearchParameters = ko.observable();

        // api service
        self.formularyService = require("@modules/tools/formulary-search/formularyService");

        // various flags/state properties
        // self.initialLoad = ko.pureComputed(function() { return initialLoad; });
        self.isBrowseByLetterStarted = ko.observable(false);
        self.isFormSearchStarted = ko.observable(false);
        self.isSearchStarted = ko.observable(false);
        self.isSettingParameters = ko.observable(false);
        self.pageSize = ko.observable(pageSize);
        self.pageNumber = ko.observable().extend({ defaultOnNull: defaultParameters.pageNumber });
        self.fatalError = ko.observable(false);
        self.detailId = ko.observable();
        self.isLeavingForDetailPage = ko.observable(false);
        self.isBrowseEnabled = ko.observable(false); /// set to true if Browse tab is active
        self.isSearchEnabled = ko.computed(function () {
            return !self.isBrowseEnabled();
        });

        var isSystemResettingFilters = false;

        var urlParams = urlParameters.read();

        var returnUrl = getPropertyCaseInsensitive(urlParams, "return_url");
        var path = encodeURIComponent(getPropertyCaseInsensitive(urlParams, "path"));

        if (urlParams.year) {
            urlParams.year = parseInt(urlParams.year, 10); // make the year a number if set in url
        }

        self.isDrx = ko.observable(false);
        self.selectPcp = ko.observable(false);

        if (returnUrl) {
            whitelistUrlService
                .validateUrl(returnUrl)
                .done(function (data) {
                    self.isDrx(true);
                })
                .fail(function (jqXHR) {
                    console.log(jqXHR.responseJSON.Message);
                });
        }

        // ARRAY-ify urlParams
        if (urlParams.categories && !$.isArray(urlParams.categories)) {
            urlParams.categories = [urlParams.categories];
        }

        if (window.scan && window.scan.returnUrlYearMap && window.scan.returnUrlYearMap && returnUrl) {
            var year = getPropertyCaseInsensitive(window.scan.returnUrlYearMap, returnUrl);
            if (year) {
                defaultParameters.year = year;
            }
        }

        // form field values
        self.year = ko.observable().extend({ defaultOnNull: defaultParameters.year });
        self.browseLetter = ko.observable();
        self.drugName = ko.observable().extend({ defaultOnNull: defaultParameters.drugName });
        self.categories = ko.observableArray([]);

        var primaryFilters = {
            drugName: self.drugName,
            year: self.year,
            categories: self.categories,
            browseLetter: self.browseLetter
        };

        // for typeahead
        self.suggestions = ko.observableArray([]);
        //we need this to populate the updated date in the footer for the PDF
        self.contextItemId = ko.observable(window.scan.contextItemId);

        // ************************************************************************
        // OBSERVABLE ARRAYS ******************************************************
        // dropdown/checkbox options
        self.yearOptions = ko.observableArray(window.scan.aepYears);
        self.categoryOptions = ko.observableArray([]);
        self.browseLetters = ko.observable(null);

        var usedNonDefaultParams = utility.initializeFilters(self, urlParams, defaultParameters);

        // loading status
        self.loadingResults = ko.observable(false);
        self.loadingFacets = ko.observable(false);
        self.displayRequiredFieldError = ko.observable(false);
        self.displayBrowseByLetterError = ko.observable(false);
        self.displayingAlternatives = ko.observable(false);
        self.foundNonFormularyButNoAlternatives = ko.observable(false);
        self.hasSearchRun = ko.observable(false);

        self.totalResults = ko.observable(0);
        self.results = ko.observableArray();
        self.pageList = ko.observableArray([]);

        // ************************************************************************
        // Overlay ****************************************************************
        // Specialty Popup text filter
        self.categoryNameFilter = ko.observable("");
        self.categoriesTempNew = ko.observableArray(JSON.parse(JSON.stringify(self.categories())));
        self.categoriesTempOptions = ko.observableArray([]);
        self.categories.subscribe(function () {
            console.clear();
            self.categoriesTempNew(JSON.parse(JSON.stringify(self.categories())));
            // console.log("categoriesTempNew has " + self.categoriesTempNew().length + " items");
            // console.log("categories has " + self.categories().length + " items");
        });
        self.categoryOptions.subscribe(function () {
            self.categoriesTempOptions(self.categoryOptions());
        });
        // self.categoriesTempNew.subscribe(function () {
        //     console.log("categoriesTempNew has " + self.categoriesTempNew().length + " items");
        //     console.log("categories has " + self.categories().length + " items");
        // });
        self.categoriesTempOptionsFiltered = ko.computed(function () {
            return this.categoriesTempOptions().filter(function (category) {
                if (!self.categoryNameFilter() || category.text.toLowerCase().indexOf(self.categoryNameFilter().toLowerCase()) !== -1) return category;
            });
        }, this);
        self.clearCategories = function () {
            self.categoriesTempNew([]);
            $("#categoryName").val('');
        };
        self.categoriesTempNewClear = function () {
            // console.log("resetting categoriesTempNew");
            // console.log("categoriesTempNew has " + self.categoriesTempNew().length + " items");
            // console.log("categories has " + self.categories().length + " items");
            self.categoriesTempNew(JSON.parse(JSON.stringify(self.categories())));
            self.categoryNameFilter("");
        };
        self.categoriesMakeTempReal = function (data, event) {
            self.categories(JSON.parse(JSON.stringify(self.categoriesTempNew())));
            self.categoryNameFilter("");
        };

        self.topLevelCategoryOptions = ko.computed(function () {
            // only show top-level categories- not subcats
            return self.categoryOptions().filter(function (item) {
                return !item.isSubCategory;
            });
        });

        self.categoryClicked = function (ele) {
            var subCat = self.categoryOptions().filter(x => x.categoryName == ele.value);
            for (var i = 0; i < subCat.length; i++) {
                if (self.categoriesTempNew().filter(x => x == ele.value).length == 0) {
                    self.categoriesTempNew.remove(subCat[i].value);
                }
                else {
                    if (self.categoriesTempNew().filter(x => x == subCat[i].value).length == 0) {
                        self.categoriesTempNew.push(subCat[i].value);
                    }
                }
            }
            return true;
        };

        self.subCategoryClicked = function (ele) {
            // checking all sub categories are selected
            var allSelected = true;
            var subCat = self.categoryOptions().filter(x => x.categoryName == ele.categoryName);
            for (var i = 0; i < subCat.length; i++) {
                if (self.categoriesTempNew().filter(x => x == subCat[i].value).length == 0) {
                    allSelected = false;
                    break;
                }
            }

            var category = self.categoryOptions().filter(x => x.value == ele.categoryName);
            if (category.length > 0) {
                if (allSelected) {
                    self.categoriesTempNew.push(category[0].value);
                }
                else {
                    self.unselectCategory(category[0].value);
                }
            }
            return true;
        };

        self.unselectCategory = function (ele) {
            self.categoriesTempNew.remove(function (cat) {
                return cat == ele;
            });
        };

        // ************************************************************************

        // this is a computed that will change whenever the user actually changes any of the filters that appear on the page.
        self.filters = ko.computed({
            read: function () {
                focusedElement = document.activeElement;

                return {
                    year: self.year(),
                    browseLetter: self.browseLetter(),
                    drugName: self.drugName(),
                    categories: self.categories()
                };
            },
            deferEvaluation: true
        });

        var resetPage = function () {
            // this can't have clearing out the fields as it's triggered on filter changes- it would unset what was just set
            // utility.resetFiltersToDefaults(primaryFilters, defaultParameters);
            // self.browseLetter(""); // does this happen in resetFiltersToDefaults
            self.displayingAlternatives(false);
            self.foundNonFormularyButNoAlternatives(false);
            self.detailId(null);
            if (self.pageNumber() !== 1) {
                // prevents a re-search
                self.pageNumber(1);
            }
            tempResults = [];
            self.results([]);
            self.totalResults(0);
            self.displayRequiredFieldError(false);
            self.fatalError(false);
            // self.showStartingMessage(true);

            if (self.isBrowseEnabled() && !self.year()) {
                self.displayBrowseByLetterError(true);
            } else {
                self.displayBrowseByLetterError(false);
            }
        };

        self.filters.subscribe(function () {
            if (isSystemResettingFilters) {
                return false;
            }
            resetPage();
        });

        self.drugName.subscribe(function (newDrugValue) {
            if (!newDrugValue || !newDrugValue.length) {
                console.log("drugValue is empty");
                resetPage();
                loadFacets(self.searchParameters());
            } else {
                self.browseLetter("");
            }
        });

        self.urlParameters = ko.computed({
            read: function () {
                var filters = self.filters();

                return {
                    year: filters.year,
                    browseLetter: filters.browseLetter,
                    drugName: filters.drugName,
                    categories: filters.categories,
                    pageNumber: self.pageNumber(),
                    // Default URL Parameters
                    detailId: self.detailId(),
                    path: path
                };
            },
            deferEvaluation: true
        });

        self.urlParameters.subscribe(function (params) {
            urlParameters.write(params, defaultParameters);
        });

        // this combines the currently selected values into a parameters object
        // for passing to our facets/results services.
        self.searchParameters = ko.computed({
            read: function () {
                var filters = self.filters();

                if (!initialLoad) {
                    self.detailId("");
                }

                return {
                    year: filters.year,
                    drugName: filters.drugName,
                    categories: filters.categories,
                    browseLetter: filters.browseLetter,
                    pageNumber: self.pageNumber(),
                    pageSize: self.pageSize()
                };
            },
            deferEvaluation: true
        });

        self.browseParameters = function () {
            var filters = self.filters();

            return {
                year: filters.year,
                browseLetter: filters.browseLetter,
                categories: filters.categories,
                pageNumber: self.pageNumber(),
                pageSize: self.pageSize()
            };
        };

        self.browseLetters.subscribe(function () {
            if (self.browseLetter()) {
                $('a[role="tab"][href="#names"]').tab("show");
                self.isBrowseEnabled(true); // might not need this if the above sets it
            }
        });

        $('[data-bs-toggle="tab"]').on("shown.bs.tab", function (e) {
            var year = self.year();
            if ($(e.target).attr("data-bs-target").indexOf("names") > -1) {
                // console.log("browse by name is active");
                self.isBrowseEnabled(true);
            } else {
                // console.log("browse by filters is active");
                self.isBrowseEnabled(false);
            }
            self.resetFilters();

            self.year(year);
        });

        self.renderLetterLink = function (letter) {
            return letter.Count > 0 && self.year();
        };

        function loadBrowseLetters() {
            if (!self.year()) {
                return;
            }

            // console.log("about to load browse letters");

            var done = function (results) {
                // console.log("retrieved browse letters");
                self.browseLetters(results.Facets.BrowseLetters.sort(utility.sortByName));
                self.categoryOptions(results.Facets.Categories);
                self.loadingFacets(false);
            };
            var fail = function () {
                self.fatalError(true);
                self.loadingFacets(false);
            };

            self.fatalError(false);
            self.loadingFacets(true);
            var parameters = {
                year: self.year()
            };

            self.formularyService.getResults(parameters, true).done(done).fail(fail);
        }

        self.isSelectedLetter = function (letter) {
            return self.browseLetter() && letter.Value.toLowerCase() === self.browseLetter().toLowerCase();
        };

        self.letterDisplayText = function (letter) {
            return letter.Name === "0" ? "123..." : letter.Name;
        };

        function loadFacets(parameters) {
            // console.log("about to loadFacets");

            // if the form is disabled (because we're in browse mode), or if search is running
            // (the search button or a browse letter has been clicked), let the main search query
            // deal with updating facets.
            // this is only for loading facets prior to clicking the search button.
            // if (self.isBrowseEnabled() || self.isFormSearchStarted()) {
            //     return;
            // }

            self.fatalError(false);
            self.loadingFacets(true);

            self.formularyService
                .getResults(parameters, false) // facets only
                .done(function (results) {
                    // console.log("retrieved facets");
                    self.categoryOptions(results.Facets.Categories);
                    self.loadingFacets(false);
                })
                .fail(function () {
                    self.fatalError(true);
                    self.loadingFacets(false);
                });
        }

        self.hasMore = ko.computed(function () {
            if (!self.totalResults()) {
                return false;
            }

            return self.pageSize() * self.pageNumber() < self.totalResults();
        });

        self.setOptionClass = function (option, item) {
            if (item) {
                ko.applyBindingsToNode(option, { css: { child: item.isSubCategory } }, item);
            }
        };

        // this id will be used to keep track of the latest search that we performed.
        // we will throw out any search results that were not for the latest ID.
        // this helps address the scenario where the user is rapidly changing filters
        // and triggering multiple searches.
        // we only want to display results for the last set of search parameters.
        var lastSearchRequestId = 1;

        var executeBrowse = function () {
            if (!self.isAnyRequiredFieldPopulated()) {
                return;
            }

            var id = ++lastSearchRequestId;

            self.hasSearchRun(true);

            var parameters = self.browseParameters();
            // console.log(urlParameters.reduceParams(parameters, defaultParameters, false));
            self.loadingResults(true);
            self.loadingFacets(true);
            self.fatalError(false);

            gtmDataLayerPush(parameters, defaultParameters);

            self.formularyService
                .getBrowse(parameters, false)
                .done(function (results) {
                    console.log(">>>>>>>>>> executeBrowse returned " + results.CurrentResults.length + " results @ " + new Date());

                    tempResults = tempResults.concat(results.CurrentResults);
                    self.results([]); // clear out results from previous page

                    for (var i in results.CurrentResults) {
                        if (results.CurrentResults.hasOwnProperty(i)) {
                            self.results.push(new FormularyResultViewModel(self, results.CurrentResults[i], self.year()));
                        }
                    }
                    self.displayingAlternatives(results.DisplayingAlternatives);
                    self.foundNonFormularyButNoAlternatives(results.FoundNonFormularyResultsButNoAlternatives);
                    self.categoryOptions(results.Facets.Categories);

                    self.currentSearchParameters(parameters);
                    self.totalResults(results.TotalResults);
                    self.loadingResults(false);
                    self.loadingFacets(false);

                    utility.recalculatePageNumbers(self);

                    if ($(focusedElement).attr("name")) {
                        setTimeout(function () {
                            $("#" + $(focusedElement).attr("id")).focus();
                        }, 100);
                    }
                })
                .fail(function () {
                    if (id !== lastSearchRequestId) {
                        // ignore any search results that come back for previous searches
                        return;
                    }

                    self.fatalError(true);
                    self.loadingResults(false);
                    self.loadingFacets(false);
                });
        };

        var executeSearch = function () {
            if (!self.isAnyRequiredFieldPopulated()) {
                return;
            }

            // we do not want to collapse the filters if the search is triggered on initial load
            // this causes the scroll position to be incorrectly determined
            // var wasStartedByInitialLoad = initialLoad;

            var id = ++lastSearchRequestId;

            self.loadingResults(true);
            self.loadingFacets(true);
            self.fatalError(false);

            var parameters = self.searchParameters();
            // console.log(urlParameters.reduceParams(parameters, defaultParameters, false));

            gtmDataLayerPush(parameters, defaultParameters);

            self.formularyService
                .getResults(parameters, false)
                .done(function (results) {
                    if (id !== lastSearchRequestId) {
                        // ignore any search results that come back for previous searches
                        return;
                    }

                    console.log(">>>>>>>>>> executeSearch returned " + results.CurrentResults.length + " results @ " + new Date());

                    self.results([]); // clear out results from previous page
                    tempResults = tempResults.concat(results.CurrentResults);

                    for (var i in results.CurrentResults) {
                        if (results.CurrentResults.hasOwnProperty(i)) {
                            self.results.push(new FormularyResultViewModel(self, results.CurrentResults[i], self.year()));
                        }
                    }
                    self.displayingAlternatives(results.DisplayingAlternatives);
                    self.foundNonFormularyButNoAlternatives(results.FoundNonFormularyButNoAlternatives);
                    self.categoryOptions(results.Facets.Categories);
                    self.currentSearchParameters(parameters);
                    self.totalResults(results.TotalResults);
                    self.loadingResults(false);
                    self.loadingFacets(false);

                    utility.recalculatePageNumbers(self);
                    self.hasSearchRun(true);

                    if ($(focusedElement).attr("name")) {
                        setTimeout(function () {
                            $("#" + $(focusedElement).attr("id")).focus();
                        }, 100);
                    }
                })
                .fail(function () {
                    if (id !== lastSearchRequestId) {
                        // ignore any search results that come back for previous searches
                        return;
                    }

                    self.fatalError(true);
                    self.loadingResults(false);
                    self.loadingFacets(false);
                });
        };

        self.searchParameters.subscribe(function () {
            if (isSystemResettingFilters) {
                return false;
            }
            if (!self.isAnyRequiredFieldPopulated()) {
                loadFacets(self.searchParameters());
                loadBrowseLetters();
                return;
            }
            if (self.isSearchEnabled()) {
                self.beginSearch();
            } else {
                self.beginBrowse(self.filters().browseLetter);
            }
        });

        // status indicators
        self.pages = ko.computed(function () {
            return Math.ceil(self.totalResults() / self.pageSize());
        });
        self.isAEP = ko.computed(function () {
            return self.yearOptions() && self.yearOptions().length > 1;
        });
        self.isAnyRequiredFieldPopulated = function () {
            return utility.filtersHaveNonDefaultValues(primaryFilters, defaultParameters);
        };

        self.showLoadingSpinner = ko.computed(function () {
            return self.loadingResults() && !self.fatalError() && !self.showStartingMessage();
        });
        self.showStartingMessage = ko.computed(function () {
            return !self.isAnyRequiredFieldPopulated();
        });
        self.showNoResultsMessage = ko.computed(function () {
            return !self.showStartingMessage() && self.results().length === 0 && !self.loadingResults();
        });

        self.arePrimaryFiltersEnabled = ko.computed(function () {
            return !self.isAEP() || self.year();
        });
        self.areSecondaryFiltersEnabled = ko.computed(function () {
            return (!self.isAEP() || self.year()) && self.isAnyRequiredFieldPopulated();
        });

        // clear filter functions
        self.resetFilters = function () {
            self.hasSearchRun(false);
            isSystemResettingFilters = true;
            resetPage();
            utility.resetFiltersToDefaults(primaryFilters, defaultParameters);
            isSystemResettingFilters = false;
            self.beginSearch();
        };
        self.clearAll = function () {
            location.href = location.href.split("?")[0];
        };
        self.clearYear = function () {
            self.year(null);
        };

        self.clearCategory = function (item) {
            self.categories.remove(item);
        };
        self.clearDrugName = function () {
            self.drugName(null);
        };
        self.clearBrowseLetter = function () {
            $("div.search-by-letter").find("li.active").removeClass("active");
            self.browseLetter(null);
        };
        self.setFocusOnResults = function () {
            utility.setFocusOnResults();
        };
        self.loadPrev = function () {
            self.pageNumber(parseInt(self.pageNumber(), 10) - 1);
            utility.setFocusOnResults();
        };
        self.loadNext = function () {
            self.pageNumber(parseInt(self.pageNumber(), 10) + 1);
            utility.setFocusOnResults();
        };
        self.setPage = function (pageObject) {
            utility.setPageNumber(self, pageObject);
        };
        self.setLastPage = function () {
            self.pageNumber(parseInt(self.pages(), 10));
            utility.setFocusOnResults();
        };

        self.beginSearch = function () {
            self.fatalError(false);
            if (self.isAnyRequiredFieldPopulated()) {
                executeSearch();
            } else {
                loadFacets(self.searchParameters());
            }
        };
        self.beginBrowse = function () {
            executeBrowse();
        };

        self.viewDetails = function (formularyId) {
            self.isLeavingForDetailPage(true);
            self.detailId(formularyId);

            var query = {
                formularyid: formularyId,
                formularyyear: self.year(),
                // pass through URL params
                Return_URL: returnUrl,
                path: path
            };

            query = urlParameters.reduceParams(query, {});

            window.location.href = window.scan.toolDetailUrl + "?" + querystring.stringify(query);
        };

        self.pdfUrl = ko.computed(function () {
            var params = self.currentSearchParameters();

            if (!params) {
                return null;
            }

            var filteredParams = urlParameters.reduceParams(params, defaultParameters, false);

            if (self.isAEP()) {
                filteredParams.year = self.year();
            }

            filteredParams.contextItemId = self.contextItemId();
            filteredParams.pageNumber = self.pageNumber();
            filteredParams.pageSize = self.pageSize();

            // console.log(filteredParams);

            return "/controller/FormularySearchPdf/Download?" + querystring.stringify(filteredParams);
        });

        self.emailUrl = ko.computed(function () {
            var urlParts = window.location.href.split("/");

            var domain = urlParts[0] + "//" + urlParts[2],
                downloadLink = domain + self.pdfUrl(),
                subject = encodeURIComponent("Your SCAN Search"),
                body = encodeURIComponent("Download your PDF here: " + downloadLink),
                emailUrl = "mailto:?subject=" + subject + "&body=" + body;

            return emailUrl;
        });

        self.browseByLetter = function (model, event) {
            self.displayBrowseByLetterError(false);

            if (!self.year()) {
                self.displayBrowseByLetterError(true);
                return false;
            }

            var $target = $(event.target);
            var letter = $target.attr("href").split(".")[1];

            self.browseLetter(letter);
            self.drugName("");
            return false;
        };

        //////////////////////////////////////////////////////////
        /////// ON Page Load functions
        loadBrowseLetters();

        if (usedNonDefaultParams) {
            if (self.isAnyRequiredFieldPopulated()) {
                if (self.filters().browseLetter) {
                    self.beginBrowse(self.filters().browseLetter);
                } else {
                    self.beginSearch();
                }
            }
        } else {
            loadFacets(self.searchParameters());
        }
        /////// ON Page Load functions
        //////////////////////////////////////////////////////////

        initialLoad = false;
    };
});
